import { TransferSearchQuery, TransferSearchRequest, TransferSearchResultCollection } from './types'
import useAxios from '../useAxios'
import {
  pluckAddress,
  pluckAirport,
  pluckConnectingAirport,
  pluckLuggageRequirements,
  pluckOversizedLuggageRequirements,
  pluckPassengerRequirements,
} from '../../common'

import { Transfer } from '../../types'

interface TransferUpdateRequest {
  contact_first_name?: string
  contact_last_name?: string
  contact_phone?: string
  contact_email?: string
}

export interface TransferUpdateResponse {
  transfer: Transfer
}

const useTransfers = () => {
  const instance = useAxios()

  const toSearchRequest = (query: TransferSearchQuery): TransferSearchRequest => ({
    direction: query.direction,
    pickup_datetime: query.pickup_datetime,
    flight_number: query.flight_number,

    ...pluckAddress(query),
    ...pluckAirport(query),
    ...pluckPassengerRequirements(query),
    ...pluckLuggageRequirements(query),
    ...pluckOversizedLuggageRequirements(query),
  })
  const search = async (query: TransferSearchQuery) => {
    const request = toSearchRequest(query)

    return await instance.post<TransferSearchResultCollection[]>('ac/v1/transfers/search', request)
  }

  const list = async (type: 'upcoming' | 'past') => {
    return await instance.get('ac/v1/transfers', {
      params: {
        type,
      },
    })
  }

  const update = async (bookingId: string, request: TransferUpdateRequest) => {
    return await instance.put<TransferUpdateResponse>(`ac/v1/transfers/${bookingId}`, request)
  }

  return {
    list,
    update,
    search,
  }
}

export default useTransfers
